import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  return (
    <footer className="bg-background-900 border-t border-background-800/60">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-4 cursor-pointer">
              <span className="text-2xl font-heading font-black text-primary-500 tracking-tight">黑料王</span>
            </Link>
            <p className="text-sm text-foreground-500 leading-relaxed">
              专注娱乐圈内幕、明星黑料曝光的权威平台。
              <br />
              汇聚最新、最劲爆的圈内黑料资讯，深扒明星私下真实一面。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-200 mb-4">热门分类</h4>
            <div className="flex flex-col gap-2">
              {categories.slice(0, 4).map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-foreground-500 hover:text-primary-400 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-200 mb-4">更多分类</h4>
            <div className="flex flex-col gap-2">
              {categories.slice(4).map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-foreground-500 hover:text-primary-400 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-200 mb-4">关于我们</h4>
            <div className="flex flex-col gap-2">
              <Link to="/about" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors duration-200 cursor-pointer whitespace-nowrap">
                品牌介绍
              </Link>
              <Link to="/about" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors duration-200 cursor-pointer whitespace-nowrap">
                联系我们
              </Link>
              <Link to="/about" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors duration-200 cursor-pointer whitespace-nowrap">
                用户口碑
              </Link>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-800/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-600">
            &copy; {new Date().getFullYear()} 黑料王 HeiLiaoWang. 本站内容仅供娱乐参考，如有不实请及时联系更正。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors cursor-pointer whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors cursor-pointer whitespace-nowrap">免责声明</a>
            <a href="#" className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors cursor-pointer whitespace-nowrap">广告合作</a>
          </div>
        </div>
      </div>
    </footer>
  );
}